import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    OrderSubType,
    ProductType,
} from 'app/enums/label.enums'

const config: SkyNetTableConfig = {
    name: 'ContainerSelection.InternalTransports',
    tabs: [{
        name: 'Open Transports',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'orderNumber',
                filterField: 'orderNumber',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'originAirportIataCode',
                filterField: 'originAirportIataCode',
                filterType: FilterType.Array,
                width: '135px',
            },
            {
                name: 'destinationAirportIataCode',
                filterField: 'destinationAirportIataCode',
                filterType: FilterType.Array,
                width: '170px',
            },
            {
                name: 'orderSubType',
                filterField: 'orderSubType',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: OrderSubType,
            },
            {
                name: 'originLocationLocationName',
                filterField: 'originLocationLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'destinationLocationLocationName',
                filterField: 'destinationLocationLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'plannedPickup',
                filterField: 'plannedPickup',
                filterType: FilterType.DateRange,
                componentName: 'DateTimeCell',
            },
            {
                name: 'requiredContainers',
                componentName: 'RequiredContainersList',
                allowedValuesEnum: ProductType,
                sorting: false,
            },
            {
                name: 'containerSelectionUntilUtc',
                componentName: 'ContainerSelectionUntil',
                headerProps: {
                    children: 'Remaining / Overdue',
                },
            },
        ],
    }],
}

export default config
